import { domReady } from '../modules/utils.js';

class EditorialScrollTrack extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.#duplicateGroup();
  }

  #duplicateGroup() {
    const track = this.querySelector('.editorialscroll-track');
    const group = track?.querySelector('.editorialscroll-group');

    if (!track || !group) return;

    const clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  }
}

customElements.define('editorial-scroll-track', EditorialScrollTrack);
